"use client";

import styles from "./TemplatesHomepages.module.css";
import { Text } from "@zapier/design-system";
import { ZapCard } from "../ZapCard";
import { CrossDomainImage } from "../CrossDomainImage/CrossDomainImage";
import { type Template } from "@zapier/templates";

export const TemplatesSection = ({
  title,
  templates,
}: {
  title: string;
  templates: Template[];
}) => {
  return (
    <section>
      <Text
        type="PageHeader"
        tag="h2"
        margin="0 0 16px 0"
        className={styles.sectionHeader}
        color="TextDefault"
      >
        {title}
      </Text>
      <div className={styles.templatesContainer}>
        {templates.map((template) => (
          <ZapCard
            key={template.slug}
            template={template}
            size="responsive"
            href={`/templates/details/${template.slug}`}
            renderedImage={
              <CrossDomainImage
                src={
                  template.previewImage?.url ??
                  "https://images.ctfassets.net/0sppvm4cmdq7/42L9dKclk2wI6gI1Lgas4K/020b75d5c6590d7b4ea21e78a3f6e690/GenericThumbnail.png"
                }
                alt={template.previewImage?.alt ?? ""}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                style={{
                  objectFit: "cover",
                  objectPosition: "top left",
                }}
              />
            }
          />
        ))}
      </div>
    </section>
  );
};
